module.exports = __webpack_public_path__ + "static/media/19ESCAP41.a92e317c.jpg";